import { render } from "./Aluno.vue?vue&type=template&id=796b8e12&scoped=true"
import script from "./Aluno.vue?vue&type=script&lang=js"
export * from "./Aluno.vue?vue&type=script&lang=js"

import "./Aluno.vue?vue&type=style&index=0&id=796b8e12&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-796b8e12"]])

export default __exports__